"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermFunctionStrEnds = void 0;
const bus_function_factory_1 = require("@comunica/bus-function-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strends
 */
class TermFunctionStrEnds extends bus_function_factory_1.TermFunctionBase {
    constructor() {
        super({
            arity: 2,
            operator: utils_expression_evaluator_1.SparqlOperator.STRENDS,
            overloads: (0, utils_expression_evaluator_1.declare)(utils_expression_evaluator_1.SparqlOperator.STRENDS)
                .onCompatibleStringly2Typed(() => (arg1, arg2) => (0, utils_expression_evaluator_1.bool)(arg1.endsWith(arg2)))
                .collect(),
        });
    }
}
exports.TermFunctionStrEnds = TermFunctionStrEnds;
//# sourceMappingURL=TermFunctionStrEnds.js.map